import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import sanitizeHtml from "sanitize-html";

const ClientCell: FC<Props> = ({ element }) => {

  return (
    <div className={styles.wrapper}>
      <div
        dangerouslySetInnerHTML={{
          __html: sanitizeHtml(element.Client),
        }}
      ></div>
    </div>
  );
};

export default ClientCell;
